<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener('DOMContentLoaded', function() {
  // Handle square meter input
  document.querySelectorAll('.sqm-input').forEach(function(input) {
    input.addEventListener('input', function() {
      const productId = input.id.split('_')[2];
      const pricePerSqM = parseFloat(input.closest('.product').querySelector('.sqm-price').innerText.replace(/[^0-9.-]+/g, ''));
      const totalPrice = pricePerSqM * parseFloat(input.value);
      input.closest('.product').querySelector('.total-price[data-product-id="' + productId + '"]').innerText = totalPrice.toFixed(2);
    });
  });
});




